const SocialIconX = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0258 2.66113H14.1726L9.48255 8.02154L15 15.3158H10.6799L7.2962 10.8919L3.42451 15.3158H1.27646L6.29291 9.58228L1 2.66113H5.4298L8.48834 6.7048L12.0258 2.66113ZM11.2724 14.0309H12.4619L4.78343 3.87858H3.50693L11.2724 14.0309Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { SocialIconX };
